module.exports = __webpack_public_path__ + "img/accpet-invite-error.8d268078.webp";